import React from 'react';
import { useTranslation } from '@frontend/i18n';
import { breakpoints, useMatchMedia } from '@frontend/responsiveness';
import { SummaryItem } from '../../SummaryItem';
import { styles } from './styles';

const Wrapper = ({ children }: { children: React.ReactNode }) => {
  const isMobile = useMatchMedia({ maxWidth: breakpoints.small.max });

  if (isMobile) {
    return <div css={styles.collectionsSummary.mobileWrapper}>{children}</div>;
  }

  return children;
};

export const CollectionsSummary = ({ balance }: { balance?: number }) => {
  const { t } = useTranslation('payments');

  return (
    <Wrapper>
      <SummaryItem
        label={t('Total Ready to Collect')}
        amount={balance}
        loading={false}
        data-trackingid='pay-portal-invoices-btn-amountreadyocollect'
      />
    </Wrapper>
  );
};
